module.exports = __webpack_public_path__ + "img/v1-roadshow-preview-booking.f7110f07.png";